class SourenneAdLanding extends HTMLElement {
  connectedCallback() {
    this.variantControls = [...this.querySelectorAll('[data-srad-variant]')];
    this.sellingPlanControls = [...this.querySelectorAll('[data-srad-selling-plan]')];
    this.ritualControls = [...this.querySelectorAll('[data-srad-ritual]')];
    this.activeVariantInputs = [...this.querySelectorAll('[data-srad-active-variant]')];
    this.gallery = this.querySelector('[data-srad-gallery]');
    this.galleryThumbs = [...this.querySelectorAll('[data-srad-gallery-thumb]')];
    this.bundleDialog = this.querySelector('[data-srad-bundle-dialog]');
    this.sticky = this.querySelector('[data-srad-sticky]');
    this.stickyButton = this.querySelector('[data-srad-sticky-button]');
    this.primaryBuybox = this.querySelector('[data-srad-context="hero"]');
    this.finalBuybox = this.querySelector('[data-srad-context="final"]');

    this.variantControls.forEach((control) => {
      control.addEventListener('change', () => this.syncVariant(control.value));
    });
    this.sellingPlanControls.forEach((control) => {
      control.addEventListener('change', () => this.syncSellingPlan(control.value));
    });
    this.ritualControls.forEach((control) => {
      control.addEventListener('change', () => this.syncRitual(control.value));
    });
    this.galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.showVisual(thumb.dataset.sradGalleryThumb);
        if (thumb.dataset.sradGalleryThumb === 'bundle') this.bundleDialog?.showModal();
      });
    });
    this.querySelectorAll('[data-srad-preview-bundle]').forEach((button) => {
      button.addEventListener('click', () => this.bundleDialog?.showModal());
    });
    this.querySelector('[data-srad-close-bundle]')?.addEventListener('click', () => this.bundleDialog?.close());
    this.bundleDialog?.addEventListener('click', (event) => {
      if (event.target === this.bundleDialog) this.bundleDialog.close();
    });
    this.stickyButton?.addEventListener('click', () => this.submitPrimaryForm());

    const initialVariant = this.variantControls[0]?.value;
    if (initialVariant) this.syncVariant(initialVariant);
    if (this.ritualControls.length) this.syncRitual('mask');
    this.setupStickyBar();
  }

  syncVariant(variantId) {
    let price = '';
    let available = true;

    this.variantControls.forEach((control) => {
      control.value = variantId;
      const option = control.matches('select')
        ? control.querySelector(`option[value="${CSS.escape(variantId)}"]`)
        : control;
      if (option) {
        price ||= option.dataset.price || '';
        available = option.dataset.available !== 'false';
      }
    });

    this.sellingPlanControls.forEach((control) => {
      [...control.options].forEach((option) => {
        if (!option.value) {
          option.disabled = false;
          return;
        }
        const ids = (option.dataset.variantIds || '').split(/\s+/).filter(Boolean);
        option.disabled = !ids.includes(variantId);
      });
      if (control.selectedOptions[0]?.disabled) control.value = '';
    });

    if (this.ritualControls.length) {
      this.maskVariantId = variantId;
      this.maskPrice = price;
      this.maskAvailable = available;
      this.ritualControls.filter((control) => control.value === 'mask').forEach((control) => {
        control.dataset.variantId = variantId;
        control.dataset.price = price;
        control.dataset.available = String(available);
      });
      this.querySelectorAll('[data-srad-mask-price]').forEach((node) => {
        node.textContent = price;
      });
      this.syncRitual(this.selectedRitual || 'mask');
      return;
    }

    this.querySelectorAll('[data-srad-price]').forEach((node) => {
      node.textContent = price;
    });
    this.querySelectorAll('[data-srad-buybox] [ref="addToCartButton"]').forEach((button) => {
      button.disabled = !available;
      this.setButtonText(button, available ? `Add to bag — ${price}` : 'Sold out');
    });

    if (this.stickyButton) {
      this.stickyButton.disabled = !available;
      this.stickyButton.querySelector('[data-srad-sticky-price]').textContent = price;
      this.stickyButton.querySelector('[data-srad-sticky-label]').textContent = available ? 'Add to bag' : 'Sold out';
    }
  }

  syncSellingPlan(sellingPlanId) {
    if (this.selectedRitual === 'bundle') return;
    this.sellingPlanControls.forEach((control) => {
      const option = control.querySelector(`option[value="${CSS.escape(sellingPlanId)}"]`);
      control.value = option && !option.disabled ? sellingPlanId : '';
    });
  }

  syncRitual(choice) {
    const selected = this.ritualControls.find((control) => control.value === choice && !control.disabled)
      || this.ritualControls.find((control) => control.value === 'mask');
    if (!selected) return;

    this.selectedRitual = selected.value;
    this.ritualControls.forEach((control) => {
      control.checked = control.value === this.selectedRitual;
    });

    const variantId = this.selectedRitual === 'mask' ? this.maskVariantId : selected.dataset.variantId;
    const price = this.selectedRitual === 'mask' ? this.maskPrice : selected.dataset.price;
    const available = this.selectedRitual === 'mask' ? this.maskAvailable : selected.dataset.available !== 'false';

    this.activeVariantInputs.forEach((input) => { input.value = variantId; });
    this.querySelectorAll('[data-srad-product-form]').forEach((form) => {
      form.dataset.productId = selected.dataset.productId;
      form.dataset.productUrl = selected.dataset.productUrl;
      const productIdInput = form.querySelector('input[name="product-id"]');
      if (productIdInput) productIdInput.value = selected.dataset.productId;
      const animation = form.querySelector('add-to-cart-component');
      if (animation) animation.dataset.productVariantMedia = selected.dataset.mediaUrl || '';
    });
    this.sellingPlanControls.forEach((control) => {
      if (this.selectedRitual === 'bundle') control.value = '';
      control.disabled = this.selectedRitual === 'bundle';
    });

    const label = this.selectedRitual === 'bundle' ? 'Add the ritual' : 'Add the mask';
    this.querySelectorAll('[data-srad-buybox] [ref="addToCartButton"]').forEach((button) => {
      button.disabled = !available;
      this.setButtonText(button, available ? `${label} — ${price}` : 'Sold out');
    });
    if (this.stickyButton) {
      this.stickyButton.disabled = !available;
      this.stickyButton.querySelector('[data-srad-sticky-label]').textContent = available ? label : 'Sold out';
      this.stickyButton.querySelector('[data-srad-sticky-price]').textContent = price;
    }
    this.showVisual(this.selectedRitual);
  }

  showVisual(visual) {
    this.gallery?.classList.toggle('is-bundle', visual === 'bundle');
    this.galleryThumbs.forEach((thumb) => {
      thumb.setAttribute('aria-pressed', String(thumb.dataset.sradGalleryThumb === visual));
    });
  }

  setButtonText(button, text) {
    const textNode = [...button.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (textNode) textNode.textContent = ` ${text} `;
  }

  submitPrimaryForm() {
    const button = this.primaryBuybox?.querySelector('[ref="addToCartButton"]');
    if (button && !button.disabled) button.click();
  }

  setupStickyBar() {
    const heroButton = this.primaryBuybox?.querySelector('[ref="addToCartButton"]');
    if (!this.sticky || !heroButton) return;

    const footer = document.querySelector('footer');
    const finalButton = this.finalBuybox?.querySelector('[ref="addToCartButton"]');

    const update = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const heroRect = heroButton.getBoundingClientRect();
      const finalRect = finalButton?.getBoundingClientRect();
      const footerRect = footer?.getBoundingClientRect();
      const stickyHeight = this.sticky.getBoundingClientRect().height;
      const heroButtonOutsideView = heroRect.bottom <= 0 || heroRect.top >= window.innerHeight;
      const finalVisible = finalRect && finalRect.top <= window.innerHeight - stickyHeight && finalRect.bottom > 0;
      const footerVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
      this.sticky.classList.toggle('is-visible', Boolean(mobile && heroButtonOutsideView && !finalVisible && !footerVisible));
    };

    this.stickyUpdate = update;
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  disconnectedCallback() {
    if (!this.stickyUpdate) return;
    window.removeEventListener('scroll', this.stickyUpdate);
    window.removeEventListener('resize', this.stickyUpdate);
  }
}

if (!customElements.get('sourenne-ad-landing')) {
  customElements.define('sourenne-ad-landing', SourenneAdLanding);
}
